const config = {
  base_url: import.meta.env.VITE_API_BASE_URL as string,
  paystack_key: import.meta.env.VITE_PAYSTACK_KEY as string
};

export default config;
